import { useState, useEffect } from "react";
import {
    Box,
    Button,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { GridColDef } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { SubmitHandler, useForm } from "react-hook-form";
import { IGreenhouse } from "../../interfaces/IGreenhouse";
import { IBay } from "../../interfaces/IBay";
import { IZone } from "../../interfaces/IZone";
import { IBench } from "../../interfaces/IBench";
import { IItemHeader } from "../../interfaces/IItemHeader";
import { IItemDetail } from "../../interfaces/IItemDetail";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { ITray } from "../../interfaces/ITray";
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch, useAppSelector } from "../../hooks";
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import PoHeader from "./PoHeader";
import PoByItemDetails from "./PoByItemDetails"
import PoByOrderDetails from "./PoByOrderDetails";
import { IPurchaseOrder } from "../../interfaces/PurchaseOrder/IPurchaseOrder";
import { setPurchaseOrderDetails } from "../../slices/purchaseOrderSlice";

const steps = ['Phase 1', 'Phase 2'];

const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', width: 230 },
    { field: 'description', headerName: 'Description', width: 230 },
    { field: 'allocatedSpace', headerName: 'Allocated Space', width: 230 },
    { field: 'availableSpace', headerName: 'Available Space', width: 230 },
];

interface WorkLogRow {
    description: string,
    material: string,
    size: string,
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

type Props = {
    setTabValue: React.Dispatch<React.SetStateAction<number>>,
    setDetailType: (props: string) => void,
    isOrderDetail: boolean,
    isItemDetail: boolean,
    setAllowReview: React.Dispatch<React.SetStateAction<boolean>>,
}

export default function PoReview(props: Props) {
    const { setTabValue, setDetailType, isItemDetail, isOrderDetail, setAllowReview } = props;
    const [openSuccess, setSuccess] = React.useState(false);

    const handleSuccess = () => {
        setSuccess(true);
    };

    const handleSuccessClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSuccess(false);
    };

    const dispatch = useAppDispatch();

    useEffect(() => {
        let appState: IApplication = {
            pageTitle: "Purchase Order - Review",
            backgroundPath: "/assets/images/inventorybg.jpg"
        }
        dispatch(setPageTitle(appState));
    }, []);

    const [itemHeaders, setItemHeaders] = React.useState<IItemHeader[]>([]);
    const [itemDetails, setItemDetails] = React.useState<IItemDetail[]>([]);
    const [selectedItemDetail, setSelectedItemDetail] = React.useState<IItemDetail>();
    const [greenHouses, setGreenHouses] = React.useState<IGreenhouse[]>([]);
    const [currentGreenhouse, setCurrentGreenhouse] = React.useState<IGreenhouse>();
    const [bays, setBays] = React.useState<IBay[]>([]);
    const [currentBay, setCurrentBay] = React.useState<IBay>();
    const [zones, setZones] = React.useState<IZone[]>([]);
    const [currentZone, setCurrentZone] = React.useState<IZone>();
    const [benches, setBenches] = React.useState<IBench[]>([]);
    const [currentBench, setCurrentBench] = React.useState<IBench>();

    const [rows, setRows] = useState<IGreenhouse[] | IBay[] | IZone[] | IBench[] | ITray[]>([]);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/ItemHeaders`)
            .then(res => {
                console.log("Response", res);
                setItemHeaders(res.data);
            });
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/ItemDetails`)
            .then(res => {
                console.log("Response", res);
                setItemDetails(res.data);
            });
        axios
            .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses`)
            .then(res => {
                console.log("Response", res);
                setGreenHouses(res.data);
            });
    }, []);

    useEffect(() => {
        if (currentGreenhouse) {
            setBays(currentGreenhouse.bays)
            setRows(currentGreenhouse.bays);
        } else {
            setBays([]);
            setRows([])
            setCurrentBay(undefined);
        }
    }, [currentGreenhouse])

    useEffect(() => {
        if (currentBay) {
            setZones(currentBay.zones)
            setRows(currentBay.zones);
        } else {
            setZones([]);
            if (currentGreenhouse && currentGreenhouse.bays) {
                setRows(currentGreenhouse.bays);
            }
            setCurrentZone(undefined);
        }
    }, [currentBay])

    useEffect(() => {
        if (currentZone) {
            setBenches(currentZone.benches)
            setRows(currentZone.benches);
        } else {
            setBenches([]);
            if (currentBay && currentBay.zones) {
                setRows(currentBay.zones);
            }
        }
    }, [currentZone])

    useEffect(() => {
        if (currentBench) {
            // setRows(currentBench.trays)
        } else {
            setBenches([]);
        }
    }, [currentBench])

    let history = useNavigate();
    const Item = styled(Paper)(({ theme }) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#191919' : '#fff',
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: 0,
        borderRadius: 0,
        boxShadow: "none",
        backgroundImage: "none",

    }));


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    interface IFormInput {
        ItemNumber: string
        Type: string
        Name: string
        Item: IItemHeader
        ItemDetail: IItemDetail,
        TraySize: number,
        Species: string,
        Variety: string,
        Color: string,
        Description: string,
        CropTime: number,
        IsTransferType: boolean,
        CustomerName: string,
        Quantity: number,
        Buffer: number,
        StartingBarcode: string,
        SowDate: string,
        SowWeek: number,
        ProductionDate: string,
        ProductionWeek: number,
        EnteredBy: string,
        AP: string,
        TransferTrayTime: number
    }

    const { register, handleSubmit, control, formState: { errors }, getValues, reset } = useForm<IPurchaseOrder>();
    const currentPurchaseOrder = useAppSelector((state) => state.purchaseOrder.purchaseOrder);
    const currentPurchaseOrderDetails = useAppSelector((state) => state.purchaseOrderDetails.purchaseOrderDetails);
    const onSubmit: SubmitHandler<IPurchaseOrder> = data => {
        if (currentPurchaseOrder) {
            console.log("CURRENT PURCHASE ORDER DETAILS", currentPurchaseOrderDetails);
            dispatch(setPurchaseOrderDetails(currentPurchaseOrderDetails));
            // currentPurchaseOrder.purchaseOrderDetails = currentPurchaseOrderDetails;
            SavePurchaseOrder(currentPurchaseOrder);
        }
        
    };

    const trayColumns: GridColDef[] = [
        //{ field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', width: 250 },
        { field: 'description', headerName: 'Description', width: 350 },
        { field: 'species', headerName: 'Species', width: 300 },
        { field: 'variety', headerName: 'Variety', width: 250 },
        { field: 'color', headerName: 'Color', width: 200 },
    ];

    const [trayRows, setTrayRows] = useState<ITray[]>([]);

    return (
        <Box id="mainForm" component="form">
            <Grid container spacing={0}>
                <Grid item xs={12} bgcolor='rgba(255, 255, 255, 1)'>
                    <Grid spacing={0} >
                        <PoHeader setTabValue={setTabValue} setDetailType={setDetailType} hideButtons={true}></PoHeader>
                    </Grid>
                    <Grid spacing={0}>
                        {isItemDetail && <PoByItemDetails setTabValue={setTabValue} setAllowReview={setAllowReview} hideButtons={true}></PoByItemDetails>}
                        {isOrderDetail && <PoByOrderDetails setTabValue={setTabValue} setAllowReview={setAllowReview} hideButtons={true}></PoByOrderDetails>}
                    </Grid>
                </Grid>
                <Grid item xs={12} sx={{ mb: 2, mt: 1 }}><Divider /></Grid>
                <Grid container spacing={0} >
                    <Grid item xs={5} sx={{ p: 1 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ p: 2 }}
                            size="large"
                            onClick={(e) => { setTabValue(1) }}
                        >
                            <Typography variant="h5">
                                Edit Order Items
                            </Typography>
                        </Button>
                    </Grid>
                    <Grid item xs={5} sx={{ p: 1 }}>
                        <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            sx={{ p: 2 }}
                            size="large"
                            endIcon={<CheckCircleIcon />}
                            onClick={(e) => { handleSubmit(onSubmit)(); }}
                        >
                            <Typography variant="h5">
                                Submit Order
                            </Typography>
                        </Button>
                    </Grid>
                    <Grid item xs={2} sx={{ p: 1 }}>
                        <Item sx={{ bgcolor: 'transparent' }}><FormControlLabel control={<Checkbox defaultChecked />} label="Running PO" /></Item>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}

function SavePurchaseOrder(currentPurchaseOrder: IPurchaseOrder) {
    console.log("CURRENT PO", currentPurchaseOrder);
    axios.post(`${process.env.REACT_APP_ENDPOINT}/api/PurchaseOrders`,
        currentPurchaseOrder
    ).then((data) => {
        console.log(data);
        if (data.status === 204) {
        };
    }).catch(x => { console.log(x.message); });
}
